import { useEffect, useRef, useState } from "react";
import { getRule } from "~/services/businessRule.services";
import { useBusinessRule } from "~/hooks/businessRule/use-businessRule";
import DynamicForm from "./RuleForm";

const CreateRule = ({ closeModal, type, ruleId }: any) => {
    const { extractionFields, businessRules } = useBusinessRule();
    const [schema, setSchema] = useState(businessRules.createrule);
    const [fieldToOperatorMap, setFieldToOperatorMap] = useState({});

    const [initialData, setInitialData] = useState(type === "edit" ? null : {
        "businessrule": {
            "rulename": "",
            "ruledescription": "",
            "priority": null
        },
        "businessrulecondition": [{}],
        "businessruleaction": [{}]
    })

    useEffect(() => {
        if (businessRules.createrule && extractionFields.data?.length) {
            const operators: { [key: string]: string } = {};
            const fieldOperatorMap: { [key: string]: object} = {};
            const fields = extractionFields.data.reduce((acc: { [key: string]: string }, item: any) => {
                acc[item.dbfieldname] = item.fieldname;
                fieldOperatorMap[item.dbfieldname] = {
                    operator: item.businessruleoperator,
                    regex: item.businessruleregex,
                    errorMessage: item.businessruleregexmessage
                };
                item.businessruleoperator.split(",").forEach((operator: string) => {
                    operators[operator] = operator;
                });
                return acc;
            }, {});

            const schemaCopy = {
                ...businessRules.createrule,
                fields: businessRules.createrule.fields.map((field: { id: string, fields: { id: string, options: object }[] }) => {
                    if (field.id === "businessrule") {
                        return {
                            ...field,
                            fields: field.fields.filter(f => f.id !== "ruledescription")  // 👈 remove ruledescription
                        };
                    }
                    if (["businessrulecondition", "businessruleaction"].includes(field.id)) {
                        return {
                            ...field,
                            fields: field.fields.map((f) => {
                                if (f.id === "fieldname") {
                                    return { ...f, options: fields };
                                }
                                if (f.id === "fieldoperator") {
                                    return { ...f, options: operators };
                                }
                                return f;
                            })
                        };
                    }
                    return field;
                })
            };
            setSchema(schemaCopy);
            setFieldToOperatorMap(fieldOperatorMap);
        }
    }, [businessRules, extractionFields]);

    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        async function getRuleData(id: string) {
            const { data } : any = await getRule(id);
            setInitialData(data.data)
        }
        if (type === "edit" && ruleId) {
            hasFetched.current = true;
            getRuleData(ruleId)
        }
    }, [])

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-50">
            <div className="relative max-h-[90vh] overflow-y-auto">
                <div className="min-h-screen bg-gray-100 py-4 px-4 rounded-md">
                    <div className="flex justify-between items-center">
                        <h1 className="text-2xl font-bold text-start mb-2">{type === "edit" ? "Edit" : "Create"} Rule</h1>
                        <button
                            onClick={() => closeModal()}
                            title="Close"
                            className="text-gray-500 hover:text-gray-800 text-2xl font-bold focus:outline-none"
                        >
                            ×
                        </button>
                    </div>
                    {(schema && initialData) &&
                        (<DynamicForm closeModal={closeModal} schema={schema} initialData={initialData} fieldToOperatorMap={fieldToOperatorMap} type={type} ruleId={ruleId} />)}
                    {(!schema || !initialData) && <div className="p-4 text-center text-gray-500 w-[674px]">Loading form...</div>}
                </div>
            </div>
        </div>
    );
};

export default CreateRule;
